import React from 'react';
import { Card } from '@/components/shared/card';
import ValueSlider from './ValueSlider';
import { Weights } from '@/types/opportunity';

interface ChallengeFactorsCardProps {
  weights: Weights;
  onWeightChange: (key: keyof Weights, value: number[]) => void;
}

const challengeFactors = [
  { 
    key: 'CostAndEffort', 
    label: 'Cost and Effort',
    subtext: "Implementation costs including software, training, and staff time required for deployment"
  },
  { 
    key: 'Risk', 
    label: 'Risk',
    subtext: "Potential challenges including technical issues, user adoption, and integration complexity"
  },
  { 
    key: 'Complexity', 
    label: 'Complexity',
    subtext: "Level of technical sophistication and organizational change management required"
  },
];

const ChallengeFactorsCard = ({ weights, onWeightChange }: ChallengeFactorsCardProps) => {
  return (
    <Card className="p-4 sm:p-6 lg:p-8 relative flex flex-col h-full">
      <span className="absolute top-4 sm:top-6 lg:top-8 left-4 sm:left-6 lg:left-8 px-3 sm:px-5 py-1 sm:py-2 font-medium text-xs sm:text-sm text-[#3B50A2] bg-gray-200 rounded-full text-center font-geist-mono">
        STEP 2
      </span>
      <h3 className="text-2xl sm:text-3xl font-medium mb-3 sm:mb-4 mt-8 sm:mt-10 lg:mt-12">What are you most keen to minimize?</h3>
      <p className="text-sm sm:text-base lg:text-lg text-gray-600 mb-6 sm:mb-8 font-light min-h-[60px] sm:min-h-[80px] max-h-[80px] leading-relaxed">
      Drag the slider to the right to indicate a <b>higher sensitivity</b> to
challenges. We'll use your responses to help filter out solutions
that might be too risky or complex.
      </p>
      <div className="flex flex-col flex-1">
        <div className="space-y-4 sm:space-y-6">
          {challengeFactors.map(({ key, label, subtext }, index) => (
            <ValueSlider
              key={key}
              label={label}
              subtext={subtext}
              value={weights[key as keyof typeof weights]}
              onChange={(value) => onWeightChange(key as keyof typeof weights, value)}
              isChallengeMetric={true}
              isLastItem={index === challengeFactors.length - 1}
            />
          ))}
        </div>
        {/* This empty div will push the content up and fill the remaining space */}
        <div className="flex-auto mt-6"></div>
      </div>
    </Card>
  );
};

export default ChallengeFactorsCard;